import React from 'react';
const Component = (props) => {
  return ( 
    <div className="loader-container">
      <div className="loader08"></div>
    </div>
  )
}
export default Component;